import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { buildMenuItems, menuIsActive } from '../../utils/helpers';
import SvgIcon from '../../components/SvgIcon';
import GlobalContext from '../../utils/GlobalContext';

export const menuIconName = (item) => {
  const activeSuffix = !menuIsActive(item.to) ? 'Active' : '';

  return item.iconName + activeSuffix;
};

export default function MobileMenu() {
  const { locales, sectionAvailabilitySettings } = useContext(GlobalContext);
  const history = useHistory();

  const {
    bmc: {
      current: { id: bmcId },
    },
  } = useSelector((state) => state);
  const { bmcId: bmcIdFromParams } = useParams();
  const actualBmcId = bmcIdFromParams || bmcId;
  const menuItems = buildMenuItems(
    actualBmcId,
    locales,
    sectionAvailabilitySettings,
  );

  return (
    <nav className="bmc-canvas-mobile-menu" aria-label="Validate Main Areas">
      {menuItems.map((item) => (
        <button
          key={`${item.to}`}
          className={classNames('bmc-canvas-mobile-menu-item', {
            'bmc-canvas-mobile-menu-item--active': menuIsActive(item.to),
          })}
          onClick={() => {
            history.push(item.to);
          }}
          aria-label={`${item.title}`}
        >
          <div className="bmc-canvas-mobile-menu-item-icon">
            <SvgIcon name={menuIconName(item)} />
          </div>
          <div className="bmc-canvas-mobile-menu-item-title">{item.title}</div>
        </button>
      ))}
    </nav>
  );
}
